import { FetchError } from 'ofetch';

export interface IRequestBEConfig {
  cache?: 'default' | 'no-store' | 'reload' | 'no-cache' | 'force-cache' | 'only-if-cached' | boolean | undefined;
  method?: 'POST' | 'PATCH' | 'DELETE' | 'GET' | String | string | null | undefined;
  headers?: Object | null | undefined;
  body?: Object | null | undefined;
  params?: Object | null | undefined;
  signal?: AbortSignal | null | undefined;
};

// Load link into the page header
export default async function (
  route: String | string,
  method?: 'POST' | 'PATCH' | 'DELETE' | 'GET' | String | string | null,
  body?: Object | null,
  headers?: Object | null,
  params?: Object | null,
  config?: IRequestBEConfig | null
): Promise<any> {
  let content = (config ?? {});
  content.method = (method ?? (content.method ? content.method : 'GET'));
  content.headers = (headers ? JSON.parse(JSON.stringify(headers)) : content.headers);
  content.params = (params ? JSON.parse(JSON.stringify(params)) : content.params);
  if (body instanceof FormData)
    content.body = body;
  else
    content.body = (body ? JSON.parse(JSON.stringify(body)) : content.body);
  const client = useSanctumClient();
  try {
    return await client(`api/${route}`, content);
  }
  catch (e) {
    if ((e instanceof FetchError) && ((e as FetchError).response?.status === 422)) {
      console.error((e as FetchError).response?._data?.errors);
      return e;
    }
    throw(e);
  }
};
